<template>
    <div :class="'relative flex cursor-pointer flex-col items-center justify-between rounded-md ' + (files.length > 0 ? ' border-[#464851] border' : 'border-2  border-[#2BA66B] px-4 py-6 border-dashed' ) + (isDragging ? '' : '')">
      <!-- Drag and Drop Area -->
        <button
            v-if="files.length > 0" 
            class="absolute hover:opacity-80 z-10 top-2 right-2 bg-red-700 text-[#fff] rounded-full h-[30px] w-[30px] flex justify-center items-center"
            @click="removeFile(0)"
            >
        ×
        </button>
      <div
        @dragenter.prevent="onDragEnter"
        @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragLeave"
        @drop.prevent="onDrop"
        @click="openFileDialog"
        class="w-full h-full"
      >
         
        <div v-if="files.length > 0" class="flex flex-wrap w-full">
            <div class="w-full h-[200px] flex items-center justify-center relative z-1">
                <img
                v-if="isImage(files[0])"
                :src="files[0].preview"
                alt="Uploaded image"
                class="object-cover w-full h-full rounded-md"
                />
                <p v-else class="text-xs text-gray-500">{{ files[0].name }}</p>
          </div>
        </div> 

        <div v-else>
            <div class="w-full h-[108px] flex items-center justify-center ">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.3334 11.3332H11.3334V19.3332H8.66675V11.3332H0.666748V8.6665H8.66675V0.666504H11.3334V8.6665H19.3334V11.3332Z" fill="#2BA66B"/>
                </svg>
            </div>
            <p class="text-[#9E9E9E] text-center text-sm px-16">Drag & Drop file here or click on “+” to select from device directly Image file: JPEG or PNG</p>
        </div>


        <input
          ref="fileInput"
          type="file"
          class="hidden"
          :accept="accept"
          :multiple="multiple"
          @change="onFileChange"
        />
      </div>
  
    
    </div>
  </template>
  
  <script>
    import { useSnackbar } from "vue3-snackbar";
    import FileUploadApi from "@/components/manager/api";
    import {mapActions} from "vuex";

    export default {
        name: "FileDragDDrop",
        props: {
            imageUrl: {
                type: String,
                default: "", // Accept images by default
            },
            accept: {
                type: String,
                default: "image/*", // Accept images by default
            },
            multiple: {
                type: Boolean,
                default: true,
            },
            uploadResponse: {
                type: Function,
                default: true,
            },
        },
        setup() {
            const snackbar = useSnackbar();
            return {
                snackbar,
            };
        },
        data() {
            return {
                isDragging: false,
                files: [], // Store files with previews
                isUploading: false, // Upload state
            };
        },
        watch: {
            imageUrl(val) {
                if(val) {
                    this.files.push({
                        type: `image/${val.split('.')[0]}`,
                        preview: val
                    })
                }
            }
        },
        mounted() {
            if(this.imageUrl) {
                this.files.push({
                    type: `image/${this.imageUrl.split('.')[0]}`,
                    preview: this.imageUrl
                })
            }
        },
        methods: {
            // Handle drag events
            onDragEnter() {
                this.isDragging = true;
            },
            onDragOver() {
                this.isDragging = true;
            },
            onDragLeave() {
                this.isDragging = false;
            },
            onDrop(event) {
                this.isDragging = false;
                const droppedFiles = Array.from(event.dataTransfer.files);
                this.processFiles(droppedFiles);
            },
            // Open file dialog
            openFileDialog() {
                this.$refs.fileInput.click();
            },
            onFileChange(event) {
                const selectedFiles = Array.from(event.target.files);
                this.processFiles(selectedFiles);
            },
            processFiles(fileList) {
                const newFiles = fileList.map((file) => {
                if (file.type.startsWith("image/")) {
                    file.preview = URL.createObjectURL(file);
                }
                return file;
                });
            
                if(newFiles[0]?.preview)  {
                    this.uploadToserver(newFiles[0])
                    this.files = this.multiple ? [...this.files, ...newFiles] : newFiles;
                } else {
                    this.snackbar.add({
                        type: 'info',
                        text: 'Sorry invalid file format, support png/jpeg/jpg.',
                        duration: 3000,
                    })
                }
            },
            isImage(file) {
                return file.type.startsWith("image/");
            },
            removeFile(index) {
                this.uploadResponse('')
                this.files.splice(index, 1);
            },

            async uploadToserver(file) {
                this.va_spinner(true)
                // get presigned url
                let presignedData = {
                    content_type: file.type,
                    name: file.name
                }
                let presignedUrlData = await FileUploadApi.getPresignedUrl(presignedData)
                if(presignedUrlData?.data?.payload?.upload_url){
                    let uploadFile =  await FileUploadApi.uploadResource(presignedUrlData.data.payload.upload_url, file);
                    if(uploadFile.status == 200 ) {
                        this.uploadResponse(presignedUrlData?.data?.payload?.full_url)
                    }  else {
                        this.va_spinner(false)
                        this.snackbar.add({
                            type: 'info',
                            text: 'Failed to upload, please try again later.',
                            duration: 3000,
                        })
                    }   
                } else {
                    this.va_spinner(false)
                    this.snackbar.add({
                        type: 'info',
                        text: 'Failed to upload, please try again later.',
                        duration: 3000,
                    })
                }
            
            },

            ...mapActions({
                va_spinner: 'spinner/setSpinner',
            })
        },

       
    };
  </script>
  
  